import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import AgentRoute from '@/components/AgentRoute';
import LoginPage from '@/pages/LoginPage';
import ChatPage from '@/pages/ChatPage';
import AccountPage from '@/pages/AccountPage';
import WorkspacePage from '@/pages/WorkspacePage';
import BillingPage from '@/pages/BillingPage';
import PartnersPage from '@/pages/PartnersPage';
import PricingPage from '@/pages/PricingPage';
import CheckoutPage from '@/pages/CheckoutPage';
import HomePage from '@/pages/HomePage';
import WaitlistPage from '@/pages/WaitlistPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<Navigate to="/" replace />} />
      <Route path="/waitlist" element={<WaitlistPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route
        path="/chat"
        element={
          <AgentRoute>
            <ChatPage />
          </AgentRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <AccountPage />
          </ProtectedRoute>
        }
      >
        <Route index element={<WorkspacePage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="partners" element={<PartnersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
